// extracted by mini-css-extract-plugin
export default {"root":"tips___root___e403eaf5","header":"tips___header___b8da8600","copy":"tips___copy___ef13df7d","list":"tips___list___bc182928"};